export const ROUTE_PATHS = Object.freeze({
  HOME: '',
  ABOUT: 'about-us',
  CONTACT: 'contact',
  TERMS: 'terms-and-conditions',
  PRIVACY: 'privacy-policy',
});

export const NAV_LINKS = Object.freeze([
  Object.freeze({ label: 'HOME', path: `/${ROUTE_PATHS.HOME}` }),
  Object.freeze({ label: 'ABOUT US', path: `/${ROUTE_PATHS.ABOUT}` }),
  Object.freeze({ label: 'CONTACT US', path: `/${ROUTE_PATHS.CONTACT}` }),
]);

export const FOOTER_NAV_LINKS = Object.freeze([
  Object.freeze({ label: 'Home', path: `/${ROUTE_PATHS.HOME}` }),
  Object.freeze({ label: 'About Us', path: `/${ROUTE_PATHS.ABOUT}` }),
  Object.freeze({ label: 'Contact Us', path: `/${ROUTE_PATHS.CONTACT}` }),
  Object.freeze({ label: 'Terms & Conditions', path: `/${ROUTE_PATHS.TERMS}` }),
  Object.freeze({ label: 'Privacy Policy', path: `/${ROUTE_PATHS.PRIVACY}` }),
]);
